import React from 'react';
import Pic1 from '../../InstallImages/Modules/LG400BiFacial';


const lg400Link = <a href="https://www.dropbox.com/s/y3qd4lvdrfscxku/LG%20400W%2072C%20Bifacial.pdf?dl=0" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const lg400Video = <a href="https://www.youtube.com/watch?v=V__tBVQuFBM" rel="noopener noreferrer" target="_blank">Watch the Video</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                LG Solar offers precision-manufactured and market-leading solar panels for businesses and homeowners who demand high performance, reliability and consistently strong energy yield -- all from a brand they can trust. By choosing LG&##9;s long lasting, energy-efficient and sustainable solar panels, receive higher financial and environmental benefits for your business and other stakeholders.
            </p>
            <p className="specsText">
                High quality solar products are reliable, backed by great warranty programs and have longer life-cycles. For the latest solar panel models, LG is now providing 25-year product warranty. This shows LG’s confidence in developing highly-efficient, durable and outstanding products. Browse LG’s highly-efficient and reliable Solar Panels to get started.
            </p>
            <p className="specsText">
                LG's new module, NeON® 2, adopts Cello technology. Cello technology replaces 3 busbars with 12 thin wires to enhance power output and reliability. NeON® 2 demonstrates LG&#39;s efforts to increase customer&#39;s values beyond efficiency. It features enhanced 25-year warranty, durability, performance under real environment, and aesthetic design suitable for roofs. LG NeON® 2 has been exceeding the expectation of many as it has been recognized as the bestselling solar module in the market.
            </p>
            <p className="specsText">
                The NeON® 2 BiFacial series offers a 25-year limited warranty for performance, product and labor At 25 years, the modules are guaranteed to produce at least 95.9% of their labeled power output. LG NeON® 2 BiFacial modules use highly efficient bifacial solar cell, “NeON” applied Cello technology. Through the Cello technology, the NeON® 2 BiFacial solar panel can achieve up to 30% more energy than standard PV module.
            </p>
            <ul>
                <h1>Key Features</h1>
                <li className="specsText">Bi-facial energy yield can produce up to 30% more energy from backside of module</li>
                <li className="specsText">Allows for more generation on a cloudy day</li>
                <li className="specsText">25 Year Product Warranty</li>
                <li className="specsText">Streamlined, Uniform Roof Aesthetic</li>
                <li className="specsText">Durable design</li>
                <li className="specsText">{lg400Video}</li>
                <li className="specsText">{lg400Link}</li>
            </ul>
        </div>
    </div>
);

export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/lg400bif.js